import React from 'react';
import { Done, DoneAll } from '@material-ui/icons';
import ReplyIcon from '@material-ui/icons/Reply';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
	myMessage: {
		float: 'right',
		margin: 5
	},
	otherMessage: {
		float: 'left',
		margin: 5
	},
	icons: {
		opacity: 0.2,
		'&:hover, &:focus': {
			opacity: 0.9
			// transform: scale(1.5)
		}
	}
});

// const Message = ({ chat, UserId, reply, deleteMessage, hasReply }) => {
// const Message = ({ chat, UserId, reply, deleteMessage }) => {
// 	// console.log('this.props.hasReply', hasReply);
// 	const owner = parseInt(UserId) === parseInt(chat.user_id);
// 	const classes = useStyles();


// 	return (
// 		<div
// 			key={chat.key}

			
// 			className={

// 					owner ? 'chat_item me' :
// 					'chat_item'
// 			}
// 		>
// 			<div className="main_item_chat">
// 				<div className="text_chat">
// 					<p>{chat.message}</p>
// 				</div>
// 				<div className="clearfix" />
// 				<time>{chat.created_at}</time>
// 				{
// 					owner ? <span className="seen">
// 						{
// 							chat.seen_audience ? <DoneAll /> :
// 							<Done />}
// 					</span> :
// 					null}

// 				<div className="clearfix" />
// 			</div>
// 			{
// 				owner ? <div className="control_message" style={{ display: 'inline' }}>
// 					<ReplyIcon className="reply_message" onClick={() => reply(chat)} />
// 					<DeleteIcon className="delete_message" onClick={() => deleteMessage(chat)} />{' '}
// 				</div> :
// 				<div className="control_message" style={{ display: 'inline', float: 'left' }}>
// 					<ReplyIcon className="reply_message" onClick={() => reply(chat)} />
// 				</div>}
// 			<div className="clearfix" />
// 		</div>
// 	);
// };

const Message = ({ chat, UserId, reply, deleteMessage }) => {
    const owner = parseInt(UserId) === parseInt(chat.user_id);
    const classes = useStyles();

    return (
        <div
            key={chat.key}
            className={owner ? 'chat_item me' : 'chat_item'}
        >
            <div className="main_item_chat">
                <div className="text_chat">
                    <p>{chat.message}</p>
                </div>
                <div className="clearfix" />
                <time>{chat.created_at}</time>
                {owner && (
                    <span className="seen">
                        {chat.seen_audience ? <DoneAll /> : <Done />}
                    </span>
                )}
                <div className="clearfix" />
            </div>
            {owner ? (
                <div className="control_message" style={{ display: 'inline' }}>
                    <ReplyIcon className="reply_message" onClick={() => reply(chat)} />
                    <DeleteIcon className="delete_message" onClick={() => deleteMessage(chat)} />
                </div>
            ) : (
                <div className="control_message" style={{ display: 'inline', float: 'left' }}>
                    <ReplyIcon className="reply_message" onClick={() => reply(chat)} />
                </div>
            )}
            <div className="clearfix" />
        </div>
    );
};

export default Message;
